import React, { useState, useEffect } from 'react';
import {
  Box,
  Flex,
  Input,
  Button,
  Select as ChakraSelect,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  SimpleGrid,
  InputLeftElement,
  Progress,
  InputGroup,
  useToast,
  Card,
  useColorMode,
  Skeleton,
  // keyframes,
  Text,
  Radio,
  RadioGroup,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  IconButton,
} from '@chakra-ui/react';
import Select from 'react-select';
import { useColorModeValue } from '@chakra-ui/react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { format, set } from 'date-fns';
import DevelopmentTable from './tables/DevelopmentTable';
import { SearchIcon, DownloadIcon, ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import axiosInstance from 'axiosInstance';
import baseUrl from 'Base_Url/baseUrl';
import axios from 'axios';
import moment from 'moment-timezone';
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const AnalyticsPage = () => {
  const [search, setSearch] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pid, setPid] = useState('All');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [graphData, setGraphData] = useState({ labels: [], datasets: [] });
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingGraph, setLoadingGraph] = useState(false);
  const [loadingProductId, setLoadingProductId] = useState(false);
  const Token = localStorage.getItem('token');
  const [productId, setProductId] = useState([]);
  const [selectedPID, setSelectedPID] = useState('');
  const [selectedProductId, setSelectedProductId] = useState('');
  const [pidData, setPidData] = useState([]);
  const [totalResult, setTotalResult] = useState();
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const productIdOptions = [{ value: '', label: 'All' }, ...productId];
  const productIdOptions2 = [...productId];
  const toast = useToast();
  const [graphPid, setGraphPid] = useState('');
  
  const [graphPreset, setGraphPreset] = useState('Last 7 Days');
  const [graphStartDate, setGraphStartDate] = useState(moment().subtract(6, 'days').format('YYYY-MM-DD'));
  const [graphEndDate, setGraphEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [graphInterval, setGraphInterval] = useState('1h');
  const [graphPage, setGraphPage] = useState(1);
  const [graphTotalPages, setGraphTotalPages] = useState(1);
  const [graphTableData, setGraphTableData] = useState([]);
  const { colorMode } = useColorMode();
  const [graphExpiry, setGraphExpiry] = useState('');
  const [downloadFormat, setDownloadFormat] = useState('excel');

  // Motor Running Hours & Flow Rate Analytics states
  const [motorPid, setMotorPid] = useState('');
  const [motorPreset, setMotorPreset] = useState('Last 7 Days');
  const [motorStartDate, setMotorStartDate] = useState(moment().subtract(6, 'days').format('YYYY-MM-DD'));
  const [motorEndDate, setMotorEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [motorTableData, setMotorTableData] = useState([]);
    const [loadingMotor, setLoadingMotor] = useState(false);
  const [downloadingMotor, setDownloadingMotor] = useState(false);
  const [downloadingGraph, setDownloadingGraph] = useState(false);

  const handleDownloadGraphData = async (format) => {
    if (!graphPid || !graphStartDate || !graphEndDate) return;
    try {
      setDownloadingGraph(true);
      const response = await axiosInstance.get(
        `${baseUrl}/device-readings/download-graph-data?productId=${graphPid}&startDate=${graphStartDate}&endDate=${graphEndDate}&interval=${graphInterval}&format=${format}`,
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );

      const mimeType = format === 'excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/pdf';
      const ext = format === 'excel' ? 'xlsx' : 'pdf';
      const blob = new Blob([response.data], { type: mimeType });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', `${graphPid}_Usage_Data_${graphInterval}_${graphStartDate}_to_${graphEndDate}.${ext}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      toast({
        title: `Usage Data report (${format.toUpperCase()}) downloaded successfully`,
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: error?.response?.data?.data || 'Failed to download report',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setDownloadingGraph(false);
    }
  };

  useEffect(() => {
    if (productId?.length > 0 && !motorPid) {
      setMotorPid(productId[0].value);
    }
  }, [productId]);

  const handleMotorPresetChange = (preset) => {
    setMotorPreset(preset);
    let start = moment();
    let end = moment();

    if (preset === 'Today') {
      start = moment();
      end = moment();
    } else if (preset === 'Yesterday') {
      start = moment().subtract(1, 'days');
      end = moment().subtract(1, 'days');
    } else if (preset === 'Last 7 Days') {
      start = moment().subtract(6, 'days');
      end = moment();
    } else if (preset === 'Last 30 Days') {
      start = moment().subtract(29, 'days');
      end = moment();
    } else if (preset === 'This Month') {
      start = moment().startOf('month');
      end = moment().endOf('month');
    }

    if (preset !== 'Custom Range') {
      setMotorStartDate(start.format('YYYY-MM-DD'));
      setMotorEndDate(end.format('YYYY-MM-DD'));
    }
  };

  const fetchMotorAnalytics = async () => {
    if (!motorPid || !motorStartDate || !motorEndDate) return;
    try {
      setLoadingMotor(true);
      const response = await axiosInstance.get(
        `${baseUrl}/device-readings/motor-analytics?productId=${motorPid}&startDate=${motorStartDate}&endDate=${motorEndDate}`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      if (response?.data?.data) {
        setMotorTableData(response.data.data.dailyData || []);
              }
    } catch (error) {
      toast({
        title: error?.response?.data?.data || 'Failed to load motor analytics',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingMotor(false);
    }
  };

  useEffect(() => {
    if (motorPid && motorStartDate && motorEndDate) {
      fetchMotorAnalytics();
    }
  }, [motorPid, motorStartDate, motorEndDate]);

  const handleDownloadMotorAnalytics = async (format) => {
    if (!motorPid || !motorStartDate || !motorEndDate) return;
    try {
      setDownloadingMotor(true);
      const response = await axiosInstance.get(
        `${baseUrl}/device-readings/download-motor-analytics?productId=${motorPid}&startDate=${motorStartDate}&endDate=${motorEndDate}&format=${format}`,
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );

      const mimeType = format === 'excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/pdf';
      const ext = format === 'excel' ? 'xlsx' : 'pdf';
      const blob = new Blob([response.data], { type: mimeType });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', `${motorPid}_Motor_Analytics_${motorStartDate}_to_${motorEndDate}.${ext}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      toast({
        title: `Motor Analytics report (${format.toUpperCase()}) downloaded successfully`,
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: error?.response?.data?.data || 'Failed to download motor report',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setDownloadingMotor(false);
    }
  };

  const selectBg = useColorModeValue('white', 'gray.700');
  const selectTextColor = useColorModeValue('black', 'white');
  const barColor = useColorModeValue('blue.400', 'blue.600');

  const customStyles = {
    container: (base) => ({
      ...base,
      width: '100%',
      // zIndex: '3',
      maxWidth: '400px',
      marginBottom: '8px',
    }),
    control: (base, state) => ({
      ...base,
      backgroundColor: colorMode === 'dark' ? '#2D3748' : '#ffffff',
      borderRadius: '20px',
      color: colorMode === 'dark' ? '#E2E8F0' : '#2D3748',
      borderColor: state.isFocused
        ? colorMode === 'dark'
          ? '#63B3ED'
          : '#3182CE'
        : '#CBD5E0',
      boxShadow: state.isFocused ? '0 0 0 1px #63B3ED' : 'none',
      '&:hover': {
        borderColor: colorMode === 'dark' ? '#63B3ED' : '#3182CE',
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: colorMode === 'dark' ? '#E2E8F0' : '#2D3748',
    }),
    placeholder: (base) => ({
      ...base,
      color: colorMode === 'dark' ? '#A0AEC0' : '#A0AEC0',
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: colorMode === 'dark' ? '#2D3748' : '#ffffff',
      color: colorMode === 'dark' ? '#E2E8F0' : '#2D3748',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused
        ? colorMode === 'dark'
          ? '#4A5568'
          : '#EDF2F7'
        : 'transparent',
      color: state.isSelected
        ? colorMode === 'dark'
          ? '#63B3ED'
          : '#3182CE'
        : base.color,
      '&:hover': {
        backgroundColor: colorMode === 'dark' ? '#4A5568' : '#EDF2F7',
      },
    }),
  };

  const getQueryString = (params) => {
    return Object.keys(params)
      .filter((key) => params[key] !== undefined && params[key] !== '')
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');
  };

  const getAllProductId = async () => {
    setLoadingProductId(true);
    try {
      const queryParams = {};
      let filter = {};

      if (Object.keys(filter).length > 0) {
        queryParams.filter = JSON.stringify(filter);
      }
      const response = await axiosInstance.get(
        `${baseUrl}/device-readings/unique?${getQueryString(queryParams)}`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        },
      );
      if (response) {
        const formattedProductIds = response?.data?.data?.data.map((pid) => ({
          value: pid,
          label: pid,
        }));
        setProductId(formattedProductIds || []);
      }
    } catch (error) {
      toast({
        title: error?.response?.data?.data
          ? error?.response?.data?.data
          : error?.response?.data?.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingProductId(false);
    }
  };

  const getDeviceData = async () => {
    setLoading(true);
    try {
      const queryParams = {
        page: page ? page : 1,
        limit: rowsPerPage,
      };
      let filter = {};

      if (selectedPID) {
        filter = {
          ...filter,
          productId: selectedPID,
        };
      }
      if (Object.keys(filter).length > 0) {
        queryParams.filter = JSON.stringify(filter);
      }
      const response = await axiosInstance.get(
        `${baseUrl}/device-readings/latest?${getQueryString(queryParams)}`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        },
      );
      if (response) {
        setPidData(response?.data?.data?.data);
        setPage(response?.data?.data?.page);
        setTotalPages(response?.data?.data?.totalPages);
        setTotalResult(response?.data?.data?.totalResults);
      }
    } catch (error) {
      toast({
        title: error?.response?.data?.data
          ? error?.response?.data?.data
          : error?.response?.data?.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const getGraphData = async () => {
    if (!graphPid || !graphStartDate || !graphEndDate) return;
    setLoadingGraph(true);
    try {
      const queryParams = {
        productId: graphPid,
        startDate: graphStartDate,
        endDate: graphEndDate,
        interval: graphInterval,
        page: graphPage,
        limit: 20
      };
      const response = await axiosInstance.get(
        `${baseUrl}/device-readings/graph?${getQueryString(queryParams)}`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        },
      );
      if (response) {
        const data = response?.data?.data?.data || [];
        setGraphTableData(data);
        setGraphTotalPages(response?.data?.data?.pagination?.totalPages || 1);

        setGraphExpiry(response?.data?.data);

        const labels = data.map(item => item.key);
        const usageData = data.map(item => item.usage);

        setGraphData({
          labels,
          datasets: [
            {
              label: `Usage Data (${graphInterval})`,
              data: usageData,
              backgroundColor: 'rgba(75, 192, 192, 0.4)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
            },
          ],
        });
      }
    } catch (error) {
      toast({
        title: error?.response?.data?.data
          ? error?.response?.data?.data
          : error?.response?.data?.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingGraph(false);
    }
  };

  useEffect(() => {
    getDeviceData();
  }, [selectedPID, page, rowsPerPage]);

  useEffect(() => {
    getAllProductId();
  }, []);

  const handleSelectChange = (selectedOption) => {
    setSelectedPID(selectedOption.value);
  };

  const handleSelectGraphChange = (selectedOption) => {
    setGraphPid(selectedOption.value);
  };

  const handleModalSelectChange = (selectedOption) => {
    setSelectedProductId(selectedOption.value);
  };



  const downloadExcel = async (productId, startDate, endDate) => {
    setLoading(true);
    if (productId === '') {
      toast({
        title: 'Product ID is required',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      setLoading(false);
      return;
    }
    if (startDate === '') {
      toast({
        title: 'Start Date is required',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      setLoading(false);
      return;
    }
    if (endDate === '') {
      toast({
        title: 'End Date is required',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      setLoading(false);
      return;
    }

    try {
      const queryParams = {};
      let filter = {};

      if (startDate && endDate) {
        const formattedStartDate = moment
          .tz(startDate, 'Asia/Kolkata')
          .format('YYYY-MM-DD');
        const formattedEndDate = moment
          .tz(endDate, 'Asia/Kolkata')
          .format('YYYY-MM-DD');

        filter = {
          ...filter,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
        };
      }

      if (productId) {
        queryParams.productId = productId;
      }
      queryParams.format = downloadFormat;

      if (Object.keys(filter).length > 0) {
        queryParams.filter = JSON.stringify(filter);
      }

      const response = await axios.get(
        `${baseUrl}/device-readings/download?${getQueryString(queryParams)}`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          responseType: 'blob',
        },
      );

      const contentType = response.headers['content-type'];
      if (contentType && contentType.includes('application/json')) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const result = JSON.parse(reader.result);
            toast({
              title: result?.data || 'Error occurred while downloading data',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
          } catch (e) {
            toast({
              title: 'Invalid response received from server',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
          }
        };
        reader.readAsText(response.data);
        setLoading(false);
      } else {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `readings_${productId}.${downloadFormat === 'pdf' ? 'pdf' : 'xlsx'}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        setIsModalOpen(false);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      if (error?.status === 403) {
        toast({
          title: 'License expired for this device',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }
      toast({
        title:
          error?.response?.data?.data ||
          error?.response?.data?.message ||
          'Failed to download the report',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (!isModalOpen) {
      setStartDate('');
      setEndDate('');
      setSelectedProductId('');
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (productId.length > 0 && !graphPid) {
      setGraphPid(productId[0].value);
    }
  }, [productId]);

  useEffect(() => {
    const today = moment().format('YYYY-MM-DD');
    switch (graphPreset) {
      case 'Today':
        setGraphStartDate(today);
        setGraphEndDate(today);
        break;
      case 'Yesterday':
        setGraphStartDate(moment().subtract(1, 'days').format('YYYY-MM-DD'));
        setGraphEndDate(moment().subtract(1, 'days').format('YYYY-MM-DD'));
        break;
      case 'Last 7 Days':
        setGraphStartDate(moment().subtract(6, 'days').format('YYYY-MM-DD'));
        setGraphEndDate(today);
        break;
      case 'Last 30 Days':
        setGraphStartDate(moment().subtract(29, 'days').format('YYYY-MM-DD'));
        setGraphEndDate(today);
        break;
      case 'This Month':
        setGraphStartDate(moment().startOf('month').format('YYYY-MM-DD'));
        setGraphEndDate(moment().endOf('month').format('YYYY-MM-DD'));
        break;
      case 'This Year':
        setGraphStartDate(moment().startOf('year').format('YYYY-MM-DD'));
        setGraphEndDate(moment().endOf('year').format('YYYY-MM-DD'));
        break;
      default:
        break;
    }
    if (graphPreset !== 'Custom Range') {
      setGraphPage(1);
    }
  }, [graphPreset]);

  useEffect(() => {
    if (graphPid) {
      getGraphData();
    }
  }, [graphPid, graphStartDate, graphEndDate, graphInterval, graphPage]);

  const renderGraphPagination = () => {
    const maxPagesToShow = 5;
    const pages = [];
    const isEllipsisShown = graphTotalPages > maxPagesToShow;

    const createPageButton = (pageNumber) => (
      <Button
        key={pageNumber}
        onClick={() => setGraphPage(pageNumber)}
        colorScheme={graphPage === pageNumber ? 'blue' : 'gray'}
        variant={graphPage === pageNumber ? 'solid' : 'outline'}
        mx="1"
      >
        {pageNumber}
      </Button>
    );

    if (isEllipsisShown) {
      if (graphPage > Math.ceil(maxPagesToShow / 2)) {
        pages.push(createPageButton(1));
        pages.push(
          <Text key="ellipsis-start" mx="1" fontSize="lg">
            ...
          </Text>,
        );
      }

      const startPage = Math.max(graphPage - Math.floor(maxPagesToShow / 2), 1);
      const endPage = Math.min(
        graphPage + Math.floor(maxPagesToShow / 2),
        graphTotalPages,
      );
      for (let i = startPage; i <= endPage; i++) {
        pages.push(createPageButton(i));
      }

      if (graphPage < graphTotalPages - Math.floor(maxPagesToShow / 2)) {
        pages.push(
          <Text key="ellipsis-end" mx="1" fontSize="lg">
            ...
          </Text>,
        );
        pages.push(createPageButton(graphTotalPages));
      }
    } else {
      for (let i = 1; i <= graphTotalPages; i++) {
        pages.push(createPageButton(i));
      }
    }

    return (
      <Flex mt="4" justify="center" align="center">
        <IconButton
          aria-label="Previous Page"
          icon={<ChevronLeftIcon />}
          isDisabled={graphPage <= 1}
          onClick={() => setGraphPage(graphPage - 1)}
          mr="2"
        />
        {pages}
        <IconButton
          aria-label="Next Page"
          icon={<ChevronRightIcon />}
          isDisabled={graphPage >= graphTotalPages}
          onClick={() => setGraphPage(graphPage + 1)}
          ml="2"
        />
      </Flex>
    );
  };

  return (
    <Box
      pt={{ base: '140px', md: '90px', xl: '90px', sm: '100px' }}
      px={{ base: '4', md: '8' }}
    >
      <Flex
        justify={{ base: 'center', md: 'space-between' }}
        align={{ base: 'stretch', md: 'center' }}
        direction={{ base: 'column', md: 'row' }}
        mb={4}
        gap={{ base: 4, md: 0 }}
      >
        <Select
          options={productIdOptions}
          value={productIdOptions?.find(
            (option) => option.value === selectedPID,
          )}
          onChange={handleSelectChange}
          placeholder="Select Product ID"
          isSearchable={true}
          styles={customStyles}
        />

        <Button
          p={5}
          leftIcon={<DownloadIcon />}
          colorScheme="green"
          onClick={() => setIsModalOpen(true)}
          w={{ base: '100%', md: 'auto' }}
        >
          Download Report
        </Button>
      </Flex>

      <DevelopmentTable
        tableData={pidData}
        handlePageChange={(newPage) => setPage(newPage)}
        handleRowClick={(row) => console.log('Row clicked:', row)}
        page={page}
        totalPages={totalPages}
        loading={loading}
      />

      <Box mt={12}>
        <Flex
          justifyContent="space-between"
          alignItems={{ base: 'flex-start', md: 'center' }}
          direction={{ base: 'column', md: 'row' }}
          gap={4}
          mb={4}
        >
          <Text fontSize="xl" fontWeight="bold">Analytics Graph & Data</Text>
          <Flex gap={2}>
            <Button
              size="sm"
              colorScheme="green"
              leftIcon={<DownloadIcon />}
              onClick={() => handleDownloadGraphData('excel')}
              isLoading={downloadingGraph}
            >
              Download Excel
            </Button>
            <Button
              size="sm"
              colorScheme="red"
              leftIcon={<DownloadIcon />}
              onClick={() => handleDownloadGraphData('pdf')}
              isLoading={downloadingGraph}
            >
              Download PDF
            </Button>
          </Flex>
        </Flex>
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={6}>
          <Select
            options={productIdOptions2}
            value={productIdOptions2?.find(
              (option) => option.value === graphPid,
            )}
            onChange={handleSelectGraphChange}
            placeholder="Select Product ID"
            isSearchable={true}
            styles={customStyles}
          />
          <ChakraSelect
            value={graphPreset}
            onChange={(e) => setGraphPreset(e.target.value)}
            bg={selectBg} color={selectTextColor} borderRadius="20px"
          >
            <option value="Today">Today</option>
            <option value="Yesterday">Yesterday</option>
            <option value="Last 7 Days">Last 7 Days</option>
            <option value="Last 30 Days">Last 30 Days</option>
            <option value="This Month">This Month</option>
            <option value="This Year">This Year</option>
            <option value="Custom Range">Custom Range...</option>
          </ChakraSelect>
          <ChakraSelect
            value={graphInterval}
            onChange={(e) => {
              setGraphInterval(e.target.value);
              setGraphPage(1);
            }}
            bg={selectBg} color={selectTextColor} borderRadius="20px"
          >
            <option value="1m">1 Minute</option>
            <option value="5m">5 Minutes</option>
            <option value="15m">15 Minutes</option>
            <option value="30m">30 Minutes</option>
            <option value="1h">1 Hour</option>
            <option value="4h">4 Hours</option>
            <option value="8h">8 Hours</option>
            <option value="12h">12 Hours</option>
            <option value="1d">1 Day</option>
            <option value="1mo">1 Month</option>
          </ChakraSelect>
        </SimpleGrid>

        {graphPreset === 'Custom Range' && (
          <Flex gap={4} mb={6}>
            <Input type="date" value={graphStartDate} onChange={(e) => { setGraphStartDate(e.target.value); setGraphPage(1); }} bg={selectBg} color={selectTextColor} />
            <Input type="date" value={graphEndDate} onChange={(e) => { setGraphEndDate(e.target.value); setGraphPage(1); }} min={graphStartDate} bg={selectBg} color={selectTextColor} />
          </Flex>
        )}

        <Card p={4} mb={6} shadow="md">
          <Text fontSize="lg" fontWeight="bold" mb={4}>Data Table</Text>
          <TableContainer>
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>Date</Th>
                  <Th>Start Time</Th>
                  <Th>End Time</Th>
                  <Th isNumeric>Opening Value</Th>
                  <Th isNumeric>Closing Value</Th>
                  <Th isNumeric>Usage (m³)</Th>
                </Tr>
              </Thead>
              <Tbody>
                {graphTableData.length > 0 ? (
                  graphTableData.map((row, idx) => (
                    <Tr key={idx}>
                      <Td>{row.date}</Td>
                      <Td>{row.startTime}</Td>
                      <Td>{row.endTime}</Td>
                      <Td isNumeric>{row.openingValue}</Td>
                      <Td isNumeric>{row.closingValue}</Td>
                      <Td isNumeric>{row.usage}</Td>
                    </Tr>
                  ))
                ) : (
                  <Tr><Td colSpan={6} textAlign="center">No data available for this range.</Td></Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
          
          {graphTotalPages > 0 && renderGraphPagination()}
        </Card>

        {loadingGraph ? (
          <Card m="auto" w="100%" h={{ base: '40vh', md: '50vh', lg: '60vh' }} p={4} shadow="md">
            <Flex direction="column" h="100%" justify="space-between" align="center">
              <Text fontSize="lg" fontWeight="bold" mb={4} color="gray.500">Loading Graph...</Text>
              <Flex w="100%" h="80%" justify="space-around" align="flex-end">
                {Array.from({ length: 8 }).map((_, index) => (
                  <Box key={index} w="10%" h="20%" bg={barColor} sx={{ animation: `barAnimation 1.5s ease-in-out ${index * 0.2}s infinite` }} borderRadius="md" />
                ))}
              </Flex>
            </Flex>
          </Card>
        ) : (
          <Card m="auto" w="100%" h={{ base: '40vh', md: '50vh', lg: '60vh' }} p={4} style={{ filter: graphExpiry?.dashboardLicensingExpiry && new Date(graphExpiry.dashboardLicensingExpiry) < new Date() ? 'blur(4px)' : 'none', pointerEvents: graphExpiry?.dashboardLicensingExpiry && new Date(graphExpiry.dashboardLicensingExpiry) < new Date() ? 'none' : 'auto' }}>
            {graphData?.labels.length > 0 ? (
              <Bar data={graphData} style={{ margin: 'auto', width: '100%', height: '100%' }} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: true, position: 'top' }, title: { display: true, text: `Graph Data for ${graphPid} (Page ${graphPage})` } } }} />
            ) : (
              <Flex justifyContent="center" alignItems="center" h="100%"><p>No data available for the selected product and range.</p></Flex>
            )}
          
        </Card>
        )}

{/* Motor Running Hours & Flow Rate Analysis Section */}
        <Card mt={6} p={5} shadow="md">
          <Flex
            justifyContent="space-between"
            alignItems={{ base: 'flex-start', md: 'center' }}
            direction={{ base: 'column', md: 'row' }}
            gap={4}
            mb={4}
          >
            <Box>
              <Text fontSize="lg" fontWeight="bold">
                Motor Running Hours & Flow Rate Analysis
              </Text>
              
            </Box>

            {/* Action Buttons */}
            <Flex gap={2}>
              <Button
                size="sm"
                colorScheme="green"
                leftIcon={<DownloadIcon />}
                onClick={() => handleDownloadMotorAnalytics('excel')}
                isLoading={downloadingMotor}
              >
                Download Excel
              </Button>
              <Button
                size="sm"
                colorScheme="red"
                leftIcon={<DownloadIcon />}
                onClick={() => handleDownloadMotorAnalytics('pdf')}
                isLoading={downloadingMotor}
              >
                Download PDF
              </Button>
            </Flex>
          </Flex>

          {/* 2 Filters Row: PID & Date Range */}
          <Flex
            gap={4}
            direction={{ base: 'column', md: 'row' }}
            alignItems="center"
            mb={4}
            flexWrap="wrap"
          >
            {/* Filter 1: Product ID */}
            <Box minW="220px" flex="1">
              <Text fontSize="xs" fontWeight="bold" mb={1} color="gray.500">
                Product ID
              </Text>
              <Select
                options={productIdOptions2}
                value={productIdOptions2.find((opt) => opt.value === motorPid)}
                onChange={(opt) => setMotorPid(opt ? opt.value : '')}
                placeholder="Select Product ID"
                isSearchable={true}
                styles={{ ...customStyles, width: '100%' }}
              />
            </Box>

            {/* Filter 2: Date Range */}
            <Box minW="220px" flex="1">
              <Text fontSize="xs" fontWeight="bold" mb={1} color="gray.500">
                Date Range
              </Text>
              <ChakraSelect
                value={motorPreset}
                onChange={(e) => handleMotorPresetChange(e.target.value)}
                borderRadius="md"
              >
                <option value="Today">Today</option>
                <option value="Yesterday">Yesterday</option>
                <option value="Last 7 Days">Last 7 Days</option>
                <option value="Last 30 Days">Last 30 Days</option>
                <option value="This Month">This Month</option>
                <option value="Custom Range">Custom Range</option>
              </ChakraSelect>
            </Box>

            {/* Custom Date Pickers if Custom Range selected */}
            {motorPreset === 'Custom Range' && (
              <Flex gap={2} alignItems="center" flex="2">
                <Box flex="1">
                  <Text fontSize="xs" fontWeight="bold" mb={1} color="gray.500">
                    From
                  </Text>
                  <Input
                    type="date"
                    size="sm"
                    value={motorStartDate}
                    onChange={(e) => setMotorStartDate(e.target.value)}
                    borderRadius="md"
                  />
                </Box>
                <Box flex="1">
                  <Text fontSize="xs" fontWeight="bold" mb={1} color="gray.500">
                    To
                  </Text>
                  <Input
                    type="date"
                    size="sm"
                    value={motorEndDate}
                    onChange={(e) => setMotorEndDate(e.target.value)}
                    borderRadius="md"
                  />
                </Box>
              </Flex>
            )}
          </Flex>

          {/* Strictly 3-Column Table */}
          <TableContainer>
            <Table variant="simple" size="sm">
              <Thead>
                <Tr>
                  <Th>Date</Th>
                  <Th>Motor Running Hours</Th>
                  <Th>Average Flow Rate</Th>
                </Tr>
              </Thead>
              <Tbody>
                {loadingMotor ? (
                  Array.from({ length: 5 }).map((_, index) => (
                    <Tr key={index}>
                      <Td><Skeleton height="20px" /></Td>
                      <Td><Skeleton height="20px" /></Td>
                      <Td><Skeleton height="20px" /></Td>
                    </Tr>
                  ))
                ) : motorTableData.length > 0 ? (
                  motorTableData.map((row, idx) => (
                    <Tr key={idx}>
                      <Td fontWeight="medium">{row.formattedDate || row.date}</Td>
                      <Td>{row.motorOnHours}</Td>
                      <Td>{row.avgFlowrate}</Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan={3} textAlign="center" py={4} color="gray.500">
                      No motor data available for the selected range.
                    </Td>
                  </Tr>
                )}
              </Tbody>
              
            </Table>
          </TableContainer>
        </Card>
      </Box>

      <Modal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Download Report</ModalHeader>
          <ModalBody>
            <FormControl mb={4}>
              <FormLabel>PID / All Selection</FormLabel>
              <Select
                options={productIdOptions}
                value={productIdOptions?.find(
                  (option) => option.value === selectedProductId,
                )}
                onChange={handleModalSelectChange}
                placeholder="Select Product ID"
                isSearchable={true}
                styles={{ ...customStyles, width: '100%' }}
              />
            </FormControl>
            <FormControl mb={4}>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                  if (endDate && new Date(e.target.value) > new Date(endDate)) {
                    // Reset endDate if it is less than startDate
                    setEndDate('');
                  }
                }}
                bg={useColorModeValue('white', 'gray.700')}
                color={useColorModeValue('black', 'white')}
                _placeholder={{
                  color: useColorModeValue('gray.500', 'gray.400'),
                }}
              />
            </FormControl>
            <FormControl mb={4}>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                min={startDate} // Prevent selecting an earlier date than startDate
                disabled={!startDate} // Disable if startDate is not selected
                bg={useColorModeValue('white', 'gray.700')}
                color={useColorModeValue('black', 'white')}
                _placeholder={{
                  color: useColorModeValue('gray.500', 'gray.400'),
                }}
              />
            </FormControl>
            <FormControl mb={4}>
              <FormLabel>Format</FormLabel>
              <RadioGroup onChange={setDownloadFormat} value={downloadFormat}>
                <Stack direction='row'>
                  <Radio value='excel'>Excel (.xlsx)</Radio>
                  <Radio value='pdf'>PDF (.pdf)</Radio>
                </Stack>
              </RadioGroup>
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={() => setIsModalOpen(false)}>
              Close
            </Button>
            <Button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                downloadExcel(selectedProductId, startDate, endDate);
              }}
              colorScheme="teal"
              ml={3}
              isLoading={loading}
            >
              Download
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default AnalyticsPage;
